import useCollectionTaiwan from '@/composables/collection/use-collection-taiwan'

export default function () {
  const collectionTaiwan = useCollectionTaiwan()

  return {
    Taiwan: collectionTaiwan,
  }
}
